import React, { useState, useEffect } from "react"; // Added useEffect
import { Link, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
  Row,
} from "reactstrap";

import classnames from "classnames";

import lightLogo from "../../assets/images/logo-light.png";
import darkLogo from "../../assets/images/logo-dark.png";
import { registerUser } from "../../api/loginApi";
import signUpImage from "../../assets/images/auth/sign-up.png";
import { Form } from "react-bootstrap";
import PhoneAuth1 from "./PhoneAuth1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faIndustry,
  faShip,
  faTruckFast,
  faSearch,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
const SignUp = () => {
  document.title = "Sign Up | StarMarket";
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "test111",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    companyName: "",
    enabled: true,
    role: localStorage.getItem("registrationType") || "processing_plant", // Get initial value from localStorage
    credentials: [
      {
        type: "password",
        value: "TestPassword123",
        temporary: false,
      },
    ],
  });

  const [activeTab, setActiveTab] = useState("1");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState(null);
  const [token, setToken] = useState(null);

  const handleTurnstileResponse = (token) => {
    setToken(token);
  };
  // useEffect to get initial value from localStorage when component mounts
  useEffect(() => {
    const storedUserType = localStorage.getItem("registrationType");
    if (storedUserType) {
      setFormData((prevData) => ({
        ...prevData,
        role: storedUserType,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      // If it's the role field, also update localStorage
      if (name === "role") {
        localStorage.setItem("registrationType", value);
      }

      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      alert("Please complete the CAPTCHA.");
      return;
    }

    // Send token to the backend for verification
    fetch("https://api.starmarketapi.online/login_firebase/verify-turnstile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // alert("Form submitted successfully!");
        } else {
          alert("Captcha verification failed.");
        }
      });
    try {
      await registerUser(formData);
      toast.success("Registration Successful!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      // Optional: Clear localStorage after successful registration
      // localStorage.removeItem("registrationType");
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    } catch (error) {
      console.error("Registration failed", error);
      toast.error("Registration failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const setPhoneNumberOut = (phoneNumber1) => {
    setPhoneNumber(phoneNumber1);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div>
        <div className="main-content">
          <div className="page-content">
            <section className="bg-auth" style={{ background: "#ffffff" }}>
              <Container>
                <Row className="justify-content-center">
                  <Col xl={10} lg={12}>
                    <div className="auth-box">
                      <Row>
                        <Col lg={6}>
                          <div className="card-body1">
                            <h1
                              style={{
                                position: "relative",
                                bottom: "10px",
                                left: "10px",
                                padding: "20px",
                              }}
                            >
                              From the sea to your home
                            </h1>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="auth-content p-5 text-blue">
                            <div className="w-100">
                              <div className="text-center text-black mb-4">
                                <h5
                                  style={{
                                    fontSize: "28px",
                                    fontWeight: "700",
                                    color: "#1a1a1a",
                                    marginBottom: "8px",
                                  }}
                                >
                                  Let's Get Started
                                </h5>
                                <p
                                  className="text-blue-70"
                                  style={{ fontSize: "15px", color: "#6c757d" }}
                                >
                                  ✨ Sign up and get access to all features of
                                  StarMarket
                                </p>
                              </div>

                              {/* Navigation Tabs */}
                              <Nav tabs className="mb-3">
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "1",
                                    })}
                                    onClick={() => setActiveTab("1")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Phone
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "2",
                                    })}
                                    onClick={() => setActiveTab("2")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Email
                                  </NavLink>
                                </NavItem>
                              </Nav>

                              {/* Tab Content */}
                              <TabContent activeTab={activeTab}>
                                {/* Sign Up Tab */}
                                <TabPane tabId="1">
                                  <form action="/" className="auth-form">
                                    <div className="mb-3">
                                      <div className="col-md-12">
                                        <label
                                          htmlFor="userType"
                                          className="form-label text-black"
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            marginBottom: "16px",
                                          }}
                                        >
                                          🎯 Select User Type
                                        </label>
                                        <div className="d-flex flex-wrap gap-3">
                                          {[
                                            {
                                              value: "buyer",
                                              label: "Buyer",
                                              icon: faShoppingCart,
                                            },
                                            {
                                              value: "processing_plant",
                                              label: "Processing Plant",
                                              icon: faIndustry,
                                            },
                                            {
                                              value: "boat_owner",
                                              label: "Boat Owner",
                                              icon: faShip,
                                            },
                                            {
                                              value: "courier",
                                              label: "Courier",
                                              icon: faTruckFast,
                                            },
                                            {
                                              value: "boat_inspector",
                                              label: "Boat Inspector",
                                              icon: faSearch,
                                            },
                                            {
                                              value: "truck_driver",
                                              label: "Truck Driver",
                                              icon: faTruck,
                                            },
                                          ].map((role) => (
                                            <label
                                              key={role.value}
                                              className={`p-3 border rounded-3 text-center flex-fill ${
                                                formData.role === role.value
                                                  ? "border-primary bg-light"
                                                  : "border-light"
                                              }`}
                                              style={{
                                                cursor: "pointer",
                                                minWidth: "140px",
                                                transition: "all 0.3s ease",
                                                boxShadow:
                                                  formData.role === role.value
                                                    ? "0 4px 12px rgba(0, 123, 255, 0.2)"
                                                    : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                                transform:
                                                  formData.role === role.value
                                                    ? "scale(1.05)"
                                                    : "scale(1)",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (
                                                  formData.role !== role.value
                                                ) {
                                                  e.currentTarget.style.boxShadow =
                                                    "0 4px 8px rgba(0, 0, 0, 0.1)";
                                                  e.currentTarget.style.transform =
                                                    "translateY(-2px)";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (
                                                  formData.role !== role.value
                                                ) {
                                                  e.currentTarget.style.boxShadow =
                                                    "0 2px 4px rgba(0, 0, 0, 0.05)";
                                                  e.currentTarget.style.transform =
                                                    "translateY(0)";
                                                }
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                name="role"
                                                value={role.value}
                                                checked={
                                                  formData.role === role.value
                                                }
                                                onChange={handleChange}
                                                style={{ display: "none" }}
                                              />
                                              <FontAwesomeIcon
                                                icon={role.icon}
                                                size="2x"
                                                className="text-primary"
                                              />
                                              <div className="mt-2 text-black fw-semibold">
                                                {role.label}
                                              </div>
                                            </label>
                                          ))}
                                        </div>
                                      </div>
                                      <div className="row mt-3">
                                        {(formData.role === "buyer" ||
                                          formData.role === "boat_owner" ||
                                          formData.role === "boat_inspector" ||
                                          formData.role === "truck_driver") && (
                                          <>
                                            <div className="col-md-6">
                                              <Input
                                                type="text"
                                                className="form-control"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                                placeholder="👤 First Name"
                                                style={{
                                                  background:
                                                    "rgb(248, 249, 252)",
                                                  color: "grey",
                                                  border: "2px solid #e9ecef",
                                                  borderRadius: "8px",
                                                  padding: "12px 16px",
                                                  fontSize: "14px",
                                                  transition: "all 0.3s ease",
                                                }}
                                                onFocus={(e) => {
                                                  e.target.style.borderColor =
                                                    "#007bff";
                                                  e.target.style.boxShadow =
                                                    "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                                }}
                                                onBlur={(e) => {
                                                  e.target.style.borderColor =
                                                    "#e9ecef";
                                                  e.target.style.boxShadow =
                                                    "none";
                                                }}
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <Input
                                                type="text"
                                                className="form-control"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                                placeholder="👤 Last Name"
                                                style={{
                                                  background:
                                                    "rgb(248, 249, 252)",
                                                  color: "grey",
                                                  border: "2px solid #e9ecef",
                                                  borderRadius: "8px",
                                                  padding: "12px 16px",
                                                  fontSize: "14px",
                                                  transition: "all 0.3s ease",
                                                }}
                                                onFocus={(e) => {
                                                  e.target.style.borderColor =
                                                    "#007bff";
                                                  e.target.style.boxShadow =
                                                    "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                                }}
                                                onBlur={(e) => {
                                                  e.target.style.borderColor =
                                                    "#e9ecef";
                                                  e.target.style.boxShadow =
                                                    "none";
                                                }}
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>

                                      <div className="row">
                                        {(formData.role === "courier" ||
                                          formData.role ===
                                            "processing_plant") && (
                                          <div className="col-md-12">
                                            <Input
                                              type="text"
                                              className="form-control"
                                              name="companyName"
                                              value={formData.companyName}
                                              onChange={handleChange}
                                              required
                                              placeholder="🏢 Company Name"
                                              style={{
                                                background:
                                                  "rgb(248, 249, 252)",
                                                color: "grey",
                                                border: "2px solid #e9ecef",
                                                borderRadius: "8px",
                                                padding: "12px 16px",
                                                fontSize: "14px",
                                                transition: "all 0.3s ease",
                                              }}
                                              onFocus={(e) => {
                                                e.target.style.borderColor =
                                                  "#007bff";
                                                e.target.style.boxShadow =
                                                  "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                              }}
                                              onBlur={(e) => {
                                                e.target.style.borderColor =
                                                  "#e9ecef";
                                                e.target.style.boxShadow =
                                                  "none";
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </form>
                                  <PhoneAuth1
                                    setPhoneNumberOut={setPhoneNumberOut}
                                    user={formData}
                                  />
                                  <div className="mt-3 text-center">
                                    <p className="mb-0 text-black">
                                      Already a member?{" "}
                                      <Link
                                        to="/signin"
                                        className="fw-medium text-blue text-decoration-underline"
                                      >
                                        Sign In
                                      </Link>
                                    </p>
                                  </div>
                                </TabPane>
                                <TabPane tabId="2">
                                  <form action="/" className="auth-form">
                                    <div className="row mb-3">
                                      <div className="col-md-12">
                                        <label
                                          htmlFor="userType"
                                          className="form-label text-black"
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            marginBottom: "16px",
                                          }}
                                        >
                                          🎯 Select User Type
                                        </label>
                                        <div className="d-flex flex-wrap gap-3">
                                          {[
                                            {
                                              value: "buyer",
                                              label: "Buyer",
                                              icon: faShoppingCart,
                                            },
                                            {
                                              value: "processing_plant",
                                              label: "Processing Plant",
                                              icon: faIndustry,
                                            },
                                            {
                                              value: "boat_owner",
                                              label: "Boat Owner",
                                              icon: faShip,
                                            },
                                            {
                                              value: "courier",
                                              label: "Courier",
                                              icon: faTruckFast,
                                            },
                                            {
                                              value: "boat_inspector",
                                              label: "Boat Inspector",
                                              icon: faSearch,
                                            },
                                            {
                                              value: "truck_driver",
                                              label: "Truck Driver",
                                              icon: faTruck,
                                            },
                                          ].map((role) => (
                                            <label
                                              key={role.value}
                                              className={`p-3 border rounded-3 text-center flex-fill ${
                                                formData.role === role.value
                                                  ? "border-primary bg-light"
                                                  : "border-light"
                                              }`}
                                              style={{
                                                cursor: "pointer",
                                                minWidth: "140px",
                                                transition: "all 0.3s ease",
                                                boxShadow:
                                                  formData.role === role.value
                                                    ? "0 4px 12px rgba(0, 123, 255, 0.2)"
                                                    : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                                transform:
                                                  formData.role === role.value
                                                    ? "scale(1.05)"
                                                    : "scale(1)",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (
                                                  formData.role !== role.value
                                                ) {
                                                  e.currentTarget.style.boxShadow =
                                                    "0 4px 8px rgba(0, 0, 0, 0.1)";
                                                  e.currentTarget.style.transform =
                                                    "translateY(-2px)";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (
                                                  formData.role !== role.value
                                                ) {
                                                  e.currentTarget.style.boxShadow =
                                                    "0 2px 4px rgba(0, 0, 0, 0.05)";
                                                  e.currentTarget.style.transform =
                                                    "translateY(0)";
                                                }
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                name="role"
                                                value={role.value}
                                                checked={
                                                  formData.role === role.value
                                                }
                                                onChange={handleChange}
                                                style={{ display: "none" }}
                                              />
                                              <FontAwesomeIcon
                                                icon={role.icon}
                                                size="2x"
                                                className="text-primary"
                                              />
                                              <div className="mt-2 text-black fw-semibold">
                                                {role.label}
                                              </div>
                                            </label>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      {(formData.role === "buyer" ||
                                        formData.role === "boat_owner" ||
                                        formData.role === "boat_inspector" ||
                                        formData.role === "truck_driver") && (
                                        <>
                                          <div className="col-md-6 mb-3">
                                            <Input
                                              type="text"
                                              className="form-control"
                                              name="firstName"
                                              value={formData.firstName}
                                              onChange={handleChange}
                                              required
                                              placeholder="First Name"
                                              style={{
                                                background:
                                                  "rgb(248, 249, 252)",
                                                color: "grey",
                                              }}
                                            />
                                          </div>
                                          <div className="col-md-6">
                                            <Input
                                              type="text"
                                              className="form-control"
                                              name="lastName"
                                              value={formData.lastName}
                                              onChange={handleChange}
                                              required
                                              placeholder="Last Name"
                                              style={{
                                                background:
                                                  "rgb(248, 249, 252)",
                                                color: "grey",
                                              }}
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    <div className="row">
                                      {(formData.role === "courier" ||
                                        formData.role ===
                                          "processing_plant") && (
                                        <div className="col-md-12 mb-3">
                                          <Input
                                            type="text"
                                            className="form-control"
                                            name="companyName"
                                            value={formData.companyName}
                                            onChange={handleChange}
                                            required
                                            placeholder="Company Name"
                                            style={{
                                              background: "rgb(248, 249, 252)",
                                              color: "grey",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="mb-3">
                                      <Input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="📧 Email Address"
                                        style={{
                                          background: "rgb(248, 249, 252)",
                                          color: "grey",
                                          border: "2px solid #e9ecef",
                                          borderRadius: "8px",
                                          padding: "12px 16px",
                                          fontSize: "14px",
                                          transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor =
                                            "#007bff";
                                          e.target.style.boxShadow =
                                            "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor =
                                            "#e9ecef";
                                          e.target.style.boxShadow = "none";
                                        }}
                                      />
                                    </div>

                                    <div className="mb-3">
                                      <Input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="🔒 Password"
                                        style={{
                                          background: "rgb(248, 249, 252)",
                                          color: "grey",
                                          border: "2px solid #e9ecef",
                                          borderRadius: "8px",
                                          padding: "12px 16px",
                                          fontSize: "14px",
                                          transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor =
                                            "#007bff";
                                          e.target.style.boxShadow =
                                            "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor =
                                            "#e9ecef";
                                          e.target.style.boxShadow = "none";
                                        }}
                                      />
                                    </div>

                                    <div className="mb-3">
                                      <Input
                                        type="password"
                                        className="form-control"
                                        placeholder="🔒 Confirm Password"
                                        style={{
                                          background: "rgb(248, 249, 252)",
                                          color: "grey",
                                          border: "2px solid #e9ecef",
                                          borderRadius: "8px",
                                          padding: "12px 16px",
                                          fontSize: "14px",
                                          transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor =
                                            "#007bff";
                                          e.target.style.boxShadow =
                                            "0 0 0 3px rgba(0, 123, 255, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor =
                                            "#e9ecef";
                                          e.target.style.boxShadow = "none";
                                        }}
                                      />
                                    </div>

                                    <div className="mb-4">
                                      <div className="form-check">
                                        <Input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="flexCheckDefault"
                                        />{" "}
                                        <label
                                          className="form-check-label text-black"
                                          htmlFor="flexCheckDefault"
                                        >
                                          I agree to the{" "}
                                          <Link
                                            to="#"
                                            className="text-blue text-decoration-underline"
                                          >
                                            Terms and conditions
                                          </Link>
                                        </label>
                                      </div>
                                    </div>

                                    <label
                                      htmlFor="emailInput"
                                      className="form-label"
                                    >
                                      {message}
                                    </label>
                                    {/* Cloudflare Turnstile Widget */}
                                    <Turnstile
                                      sitekey="0x4AAAAAABOACzBCG9VMleRw"
                                      onVerify={handleTurnstileResponse}
                                    />
                                    <div className="text-center">
                                      <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="btn-blue btn-hover w-100"
                                        style={{
                                          fontSize: "16px",
                                          fontWeight: "600",
                                          padding: "14px",
                                          borderRadius: "8px",
                                          boxShadow:
                                            "0 4px 12px rgba(0, 123, 255, 0.3)",
                                          transition: "all 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.transform =
                                            "translateY(-2px)";
                                          e.target.style.boxShadow =
                                            "0 6px 16px rgba(0, 123, 255, 0.4)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.transform =
                                            "translateY(0)";
                                          e.target.style.boxShadow =
                                            "0 4px 12px rgba(0, 123, 255, 0.3)";
                                        }}
                                      >
                                        🚀 Sign Up
                                      </button>
                                    </div>
                                  </form>

                                  <div className="mt-3 text-center">
                                    <p className="mb-0 text-black">
                                      Already a member?{" "}
                                      <Link
                                        to="/signin"
                                        className="fw-medium text-blue text-decoration-underline"
                                      >
                                        Sign In
                                      </Link>
                                    </p>
                                  </div>
                                </TabPane>
                              </TabContent>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignUp;
